import { useSelector } from 'react-redux';
import { keepPreviousData } from '@tanstack/react-query';

import { SystemEvents } from '@playq/octopus2-analytics';
import { GenericFailure } from '@playq/services-shared';
import { PermModule } from '@playq/octopus2-auth';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { appToolkit } from '/store';
import { useModulePermissions } from '/hooks/useModulePermissions';

export const eventsMapperRetrieveKeys: unknown[] = ['events-mapper', 'retrieve'];
export const systemEventsRetrieveKeys: unknown[] = eventsMapperRetrieveKeys.concat('system');

const emptyArray: [] = [];

export const useRetrieveSystemEvents = (
  options?: IUseQueryOptionsExtended<SystemEvents | undefined, GenericFailure | Error>
) => {
  const appID = useSelector(appToolkit.selectors.appID);

  const { canRead } = useModulePermissions(PermModule.AnalyticsEventsMapper);

  const res = useEitherQuery(
    systemEventsRetrieveKeys.concat(appID),
    () => {
      if (appID !== undefined) {
        return services2.appEventsMapperService.retrieveSystemEvents(appID);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
      enabled: options?.enabled !== false && canRead,
    }
  );

  return {
    ...res,
    events: res?.data?.events || emptyArray,
  };
};
